// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.organizzazione-create-form {
  display: grid;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem;
  box-sizing: border-box;
}

.organizzazione-create-card {
  width: 100%;
  margin: 0;
}

.organizzazione-create-card ion-card-header {
  padding-bottom: 0.5rem;
}

.organizzazione-create-fields {
  display: grid;
  gap: 0.875rem;
  padding-top: 0.5rem;
}

.organizzazione-create-field {
  display: grid;
  gap: 0.35rem;
}

.organizzazione-create-field ion-input,
.organizzazione-create-field ion-select {
  width: 100%;
}

.organizzazione-create-field ion-note {
  padding-inline: 0.25rem;
  color: var(--ion-color-medium);
  font-size: 0.8125rem;
  line-height: 1.35;
}

.organizzazione-create-active {
  --background: transparent;
  --padding-start: 1rem;
  --inner-padding-end: 0.75rem;
  --min-height: 5.25rem;
}

.organizzazione-create-active h2 {
  margin-bottom: 0.25rem;
  font-weight: 700;
}

.organizzazione-create-active p {
  margin: 0;
  color: var(--ion-color-medium);
  line-height: 1.35;
}

@media (max-width: 767px) {
  .organizzazione-create-form {
    gap: 0.625rem;
    padding: 0.625rem;
  }
  .organizzazione-create-card ion-card-header {
    padding: 0.875rem 0.875rem 0.375rem;
  }
  .organizzazione-create-card ion-card-content {
    padding: 0.625rem 0.875rem 0.875rem;
  }
  .organizzazione-create-fields {
    gap: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/organizzazioni/organizzazioni-create/organizzazioni-create.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,SAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;;EAEE,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,8BAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,aAAA;IACA,iBAAA;EACF;EAEA;IACE,mCAAA;EAAF;EAGA;IACE,mCAAA;EADF;EAIA;IACE,YAAA;EAFF;AACF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.organizzazione-create-form {\n  display: grid;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.75rem;\n  box-sizing: border-box;\n}\n\n.organizzazione-create-card {\n  width: 100%;\n  margin: 0;\n}\n\n.organizzazione-create-card ion-card-header {\n  padding-bottom: 0.5rem;\n}\n\n.organizzazione-create-fields {\n  display: grid;\n  gap: 0.875rem;\n  padding-top: 0.5rem;\n}\n\n.organizzazione-create-field {\n  display: grid;\n  gap: 0.35rem;\n}\n\n.organizzazione-create-field ion-input,\n.organizzazione-create-field ion-select {\n  width: 100%;\n}\n\n.organizzazione-create-field ion-note {\n  padding-inline: 0.25rem;\n  color: var(--ion-color-medium);\n  font-size: 0.8125rem;\n  line-height: 1.35;\n}\n\n.organizzazione-create-active {\n  --background: transparent;\n  --padding-start: 1rem;\n  --inner-padding-end: 0.75rem;\n  --min-height: 5.25rem;\n}\n\n.organizzazione-create-active h2 {\n  margin-bottom: 0.25rem;\n  font-weight: 700;\n}\n\n.organizzazione-create-active p {\n  margin: 0;\n  color: var(--ion-color-medium);\n  line-height: 1.35;\n}\n\n@media (max-width: 767px) {\n  .organizzazione-create-form {\n    gap: 0.625rem;\n    padding: 0.625rem;\n  }\n\n  .organizzazione-create-card ion-card-header {\n    padding: 0.875rem 0.875rem 0.375rem;\n  }\n\n  .organizzazione-create-card ion-card-content {\n    padding: 0.625rem 0.875rem 0.875rem;\n  }\n\n  .organizzazione-create-fields {\n    gap: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
